import {
  DocumentTextIcon, // Type
  PhotoIcon, // Image
  Square2StackIcon, // Stop/Square
  CursorArrowRaysIcon, // MousePointer2
  ArrowsPointingOutIcon, // Move
  TrashIcon, // Trash2
  Bars3BottomLeftIcon, // AlignLeft
  Bars3Icon, // AlignCenter
  Bars3BottomRightIcon, // AlignRight
  ArrowUpIcon, // AlignTop (approx)
  ArrowsUpDownIcon, // AlignMiddle (approx)
  ArrowDownIcon, // AlignBottom (approx)
  LinkIcon, // Anchor (approx)
  CubeIcon, // BoxSelect/Input/Container?
  CircleStackIcon, // Database
  ChevronDownIcon, // ChevronDown
  ChevronRightIcon, // ChevronRight
  PlusIcon, // Plus
  Squares2X2Icon, // Grid
  Cog6ToothIcon, // Settings
  XMarkIcon, // Remove/X
  ViewColumnsIcon, // VerticalLayout (Rows/Columns mismatch in heroicons, ViewColumns is parallel columns)
  TableCellsIcon, // HorizontalLayout?
  PlayIcon, // Play
  ArrowUturnLeftIcon, // Return
  MagnifyingGlassIcon, // Search
  DocumentDuplicateIcon,
  ClipboardDocumentIcon,
  EyeIcon,
  EyeSlashIcon,
  CheckIcon,
  HandRaisedIcon,
  ArrowLeftIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpTrayIcon
} from '@heroicons/react/24/outline';

const LockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

const UnlockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
  </svg>
);

// Mapping Lucide names to Heroicons
export const Icons = {
  Typography: DocumentTextIcon,
  Image: PhotoIcon,
  Button: CursorArrowRaysIcon,
  Container: Square2StackIcon,
  Input: CubeIcon, // Placeholder
  BoxSelect: CubeIcon,
  Move: ArrowsPointingOutIcon,
  Trash: TrashIcon,
  AlignLeft: Bars3BottomLeftIcon,
  AlignCenter: Bars3Icon,
  AlignRight: Bars3BottomRightIcon,
  AlignTop: ArrowUpIcon, // Fallback
  AlignMiddle: ArrowsUpDownIcon, // Fallback
  AlignBottom: ArrowDownIcon, // Fallback
  Anchor: LinkIcon, // Fallback
  Database: CircleStackIcon,
  ChevronDown: ChevronDownIcon,
  ChevronRight: ChevronRightIcon,
  Plus: PlusIcon,
  Grid: Squares2X2Icon,
  Settings: Cog6ToothIcon,
  Remove: XMarkIcon,
  VerticalLayout: ViewColumnsIcon, // Mapping as best guess
  HorizontalLayout: TableCellsIcon, // Mapping as best guess
  Play: PlayIcon,
  Stop: Square2StackIcon, // Fallback
  Return: ArrowUturnLeftIcon,
  Search: MagnifyingGlassIcon,
  Lock: LockIcon,
  Unlock: UnlockIcon,
  Copy: DocumentDuplicateIcon,
  Clipboard: ClipboardDocumentIcon,
  Eye: EyeIcon,
  EyeOff: EyeSlashIcon,
  Check: CheckIcon,
  Close: XMarkIcon,
  Hand: HandRaisedIcon,
  Prefab: CubeIcon,
  ArrowLeft: ArrowLeftIcon,
  ExternalLink: ArrowTopRightOnSquareIcon,
  Upload: ArrowUpTrayIcon
};
